<template>
	<div id="app">
		<Header></Header>
		<router-view />
		<Login v-if="show_login"></Login>
	</div>
</template>

<script>
	import Header from '@/common/components/header'
	import Login from '@/common/components/login'
	export default {
		mounted() {
			if(localStorage.getItem('personal_api_token')) {
				this.$store.commit('is_login', true);
			}
		},
		computed: {
			show_login() {
				return this.$store.state.show_login
			}
		},
		components: {
			Header,
			Login
		}
	}
</script>

<style>
	.page-box {
		width: 1200px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue